<template>
  <div class="min-h-screen bg-black text-white grid md:grid-cols-2">
    <div class="hidden md:flex items-center justify-center bg-gradient-to-br from-pink-600 to-blue-700">
      <img src="/image/casal.png" alt="Login Image" class="h-[950px] w-full object-cover object-top" />
    </div>

    <div class="flex items-center justify-center p-6">
      <div class="w-full max-w-md space-y-6">
        <div class="text-center">
          <img src="/image/logo.png" alt="Prime Options" class="h-20 mx-auto mb-4" />
          <h2 class="text-2xl font-semibold text-start">Identifique-se</h2>
        </div>

        <form class="space-y-4" @submit.prevent="handleSubmit">
          <input
            v-model="auth.userForm.email"
            type="email"
            placeholder="Email"
            class="w-full px-4 py-3 rounded-md bg-gray-800 text-white placeholder-gray-400 border border-gray-600 focus:outline-none focus:ring-2 focus:ring-pink-500"
          />

          <input
            v-model="auth.userForm.password"
            type="password"
            placeholder="Senha"
            class="w-full px-4 py-3 rounded-md bg-gray-800 text-white placeholder-gray-400 border border-gray-600 focus:outline-none focus:ring-2 focus:ring-pink-500"
          />

          <button
            type="submit"
            class="w-full py-3 mt-2 rounded-md bg-gradient-to-r from-pink-600 to-blue-600 hover:opacity-90 transition"
          >
            <span v-if="auth.isChecking">Aguarde...</span>
            <span v-else>ACESSAR</span>
          </button>

          <p v-if="auth.error" class="text-red-400 text-sm text-center mt-2">
            {{ auth.error }}
          </p>
        </form>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useAuthStore } from '@/stores/user'
import { onMounted } from 'vue'

const auth = useAuthStore()

const handleSubmit = () => {
  if (!auth.userForm.email || !auth.userForm.password) {
    auth.error = 'Preencha todos os campos.'
    return
  }
  auth.login()
}

onMounted(() => {
  auth.error = ''
})
</script>
